import utils from 'components/utilsComponent';
import kurortFilter from 'components/kurort/kurortFilterComponent';
import Header, {initHeaderBookingFromCookie} from 'components/kurort/header';
import {ajaxGetData} from 'methods/ajaxData';
import {triggerEvent, debounce, getCookie} from 'methods/utils';
import TabsComponent from 'components/tabsComponent';
import KurortMapModal from 'components/kurort-map-modal';
import KurortSubsetSlider from './kurort-subset-slider';
import ReviewsSlider from 'components/reviews-slider';
import Accordion from 'components/accordion';
import Faq from './components/faq';
import Tags from './components/tags';
import 'vendor/swiper.min';
import {seoExperiment1708} from 'components/seo';
import {injectNoFoundBlock} from 'components/no-found-block';
import TouristLeadsModal from 'components/tourist-leads/modal';
import metrikaCollector, {collectRetail} from 'components/metrika';
import Contacts from 'components/contacts';

/**
 * Модальное окно с телефоном поддержки
 */
const contacts = Contacts.make({
    phones: window.pageData?.supportPhones ?? [],
});

injectNoFoundBlock();

const $noFoundCall = document.querySelector('.js-no-found-call');
if ($noFoundCall) {
    $noFoundCall.addEventListener('click', () => contacts.open());
}

initHeaderBookingFromCookie();

/**
 * Модальное окно с формой заявки на персонализированный подбор
 */
if (document.querySelector('.js-createBooking')) {
    document.querySelectorAll('.js-createBooking').forEach(($createOrder) => {
        $createOrder.addEventListener('click', () => (new TouristLeadsModal()).open());
    });
}

if (seoExperiment1708()) {
    // даты есть
    if (getCookie('date_start') && getCookie('date_finish')) {
        document.querySelectorAll('.js-hotelListSkelet').forEach($item => $item.classList.remove('is-hidden'));
        document.querySelectorAll('.js-hotelList').forEach($item => $item.classList.add('is-hidden'));
        document.querySelectorAll('.js-leftFilterContainer').forEach($item => $item.classList.add('is-loading'));
    }
}

document.querySelectorAll('.js-accordion').forEach($el => {
    new Accordion($el);
});

document.querySelectorAll('.js-faq').forEach($el => {
    new Faq($el);
});

/**
 * Плитка тегов
 */
if (document.querySelector('.js-tags')) {
    new Tags(document.querySelector('.js-tags'), {useShadow: true});
}

/**
 * Слайдер подборок
 */
if (document.querySelector('.js-kurortSubsetSlider')) {
    new KurortSubsetSlider(document.querySelector('.js-kurortSubsetSlider'));
}

/**
 * Слайдер отзывов
 */
document.querySelectorAll('.js-reviewsSlider').forEach($element => new ReviewsSlider($element));

/**
 * seoExperiment2633
 */
new TabsComponent({
    'container': '.js-tabs-graphics',
    'navigation': '.Graphics__link',
    'item': '.Graphics__tabs-item',
});

/**
 * Инициализация слайдера
 */
function sliderNav($container, slider) {
    if ($container.classList.contains('swiper-init')) {
        return;
    }

    function checkButtons() {
        if (slider.isEnd) {
            $nextButton.classList.remove('is-active');
            $prevButton.classList.add('is-active');
        }

        if (slider.isBeginning) {
            $nextButton.classList.add('is-active');
            $prevButton.classList.remove('is-active');
        }

        if (!slider.isEnd && !slider.isBeginning) {
            $nextButton.classList.add('is-active');
            $prevButton.classList.add('is-active');
        }

        if (slider.isEnd && slider.isBeginning) {
            $nextButton.classList.remove('is-active');
            $prevButton.classList.remove('is-active');
        }
    }

    const $parent     = $container.parentElement;
    const $prevButton = $parent.querySelector('.js-prevButton');
    const $nextButton = $parent.querySelector('.js-nextButton');

    $container.classList.add('swiper-init');

    if (slider.slides.length > slider.params.slidesPerView) {
        $nextButton.addEventListener('click', () => {
            slider.slideNext();
            checkButtons();
        });

        $prevButton.addEventListener('click', () => {
            slider.slidePrev();
            checkButtons();
        });

        slider.on('transitionEnd', () => {
            checkButtons();
        });

    } else if ($nextButton && $prevButton) {
        $nextButton.classList.remove('is-active');
        $prevButton.classList.remove('is-active');
    }
}

/**
 * Кнопка показать еще для плитки
 */
utils.addTrigger('click', '.js-moreHotels', function(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.classList.contains('is-loading')) {
        return false;
    }
    this.classList.add('is-loading');
    this.setAttribute('disabled', 'disabled');

    kurortFilter.formRecalc({
        show_more: true,
    });
});

const header = new Header(document.querySelector('.js-header'), {
    fixed: true,
    search: true,
    openDatePickerWithoutDates: true,
});

header.on('search:change', kurortFilter.formRecalc);
header.on('search:submit', (args) => {
    if (args.redirect === true) {
        return false;
    }

    // Finds y value of given object
    function findPos(obj) {
        let curtop = 0;
        if (obj.offsetParent) {
            do {
                curtop += obj.offsetTop;
            } while (obj = obj.offsetParent);

            return curtop - 80;
        }
    }

    window.scrollTo({
        top: findPos(document.querySelector('.js-topKurortFilter')),
        behavior: "smooth"
    });
});

const searchOnMove = (function () {
    try {
        return !!window.pageData['kurort-map-modal']['search-on-move'];
    } catch (e) {
        return false;
    }
})();

const showHotelList = (function () {
    try {
        return !!window.pageData['kurort-map-modal']['show-hotel-list'];
    } catch (e) {
        return false;
    }
})();

const debouncedMapFetch = debounce(() => {
    triggerEvent('mapFetch');
}, 500);

const mapModal = new KurortMapModal(document.querySelector('.js-mapModal'), {
    header,
    kurortFilter,
    components: ['hotels', 'filters', 'search-on-move'],
    searchOnMove,
    showHotelList,
    on: {
        'close': () => {
            triggerEvent('formRecalc');
        },
        'move': () => {
            debouncedMapFetch();
        },
    }
});
const $mapModalOpen = document.querySelector('.js-mapModalOpen');

$mapModalOpen.addEventListener('click', () => mapModal.open().then(() => triggerEvent('mapFetch')));

/**
 * Получаем данные при загрузке страницы
 */
ajaxGetData()
    .then(function(r) {
        // название географии у нас только в this.$citySearch при загрузке страницы, модалка теперь на js, поэтому так
        r.data.search['search_title'] = header.$citySearch.textContent;
        r.data.search['search_href']  = header.$citySearch.dataset.href;

        // на странице с активным фильтром данные могут отсутствовать в сессии - поэтому установка принудительно
        const $withPets = document.querySelector('input[name="option_list[34]"]');
        r.data.search.with_pets |= $withPets && $withPets.checked;

        // прокидываем данные
        header.setSearchData(r.data.search);

        // быстрое бронирование для тех кто с рекламы
        const $fastBooking = document.querySelector('.js-fastBooking');
        const $fastBookingButton = document.querySelector('.js-fastBookingButton');

        if (getCookie('utm_medium') === 'cpc' && $fastBooking && $fastBookingButton) {
            $fastBooking.value = 1;
            $fastBookingButton.classList.add('is-active');
        }

        if (seoExperiment1708()) {
            // фильтры
            if (r.data.search.date_finish && r.data.search.date_start || getCookie('utm_medium') === 'cpc' || window.location.search.match(/[&?]page=(\d+)/)) {
                kurortFilter.formRecalc({
                    page: true, // чтобы постраничка не сбрасывалась при инициализации
                });
            }
        } else {
            kurortFilter.formRecalc({
                page: true, // чтобы постраничка не сбрасывалась при инициализации
            });
        }
    });

/**
 * Слайдер типов жилья
 */
function initKurortTypeSlider() {
    document.querySelectorAll('.js-kurortTypeSlider').forEach(($kurortTypeSlider) => {
        sliderNav($kurortTypeSlider, new Swiper($kurortTypeSlider, {
            containerModifierClass: 'Kurort-type__slider',
            wrapperClass: 'Kurort-type__wrapper',
            slideClass: 'Kurort-type__slide',
            slideActiveClass: 'Kurort-type__slide_active',
            slidesPerView: 4,
            spaceBetween: 20,
            breakpoints: {
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
            }
        }));
    });
}
initKurortTypeSlider();

/**
 * Слайдер курорты рядом
 */
const $kurortBesideSlider = document.querySelector('.js-kurortBesideSlider');
if ($kurortBesideSlider) {
    sliderNav($kurortBesideSlider, new Swiper($kurortBesideSlider, {
        slidesPerView: 3,
        spaceBetween: 21
    }));

    // клик по элементу внутри свайпера
    utils.addTrigger('click', '.Kurort-beside__wrapper a.Kurort-beside__link', function(e) {
        e.preventDefault();
        
        if (this.target == '_blank') {
            window.open(this.href, '_blank').focus();
        } else {
            window.location = this.href;
        }
    });
}

/**
 * Слайдер фоток курорта
 */
const $kurortAboutSlider = document.querySelector('.js-kurortAboutSlider');
if ($kurortAboutSlider) {
    sliderNav($kurortAboutSlider, new Swiper($kurortAboutSlider, {
        preventClicks: false,   // @see https://github.com/nolimits4web/swiper/issues/1152
        containerModifierClass: 'Kurort-about__slider',
        wrapperClass: 'Kurort-about__inner',
        slideClass: 'Kurort-about__slide',
        slideActiveClass: 'Kurort-about__slide_active',
        width: 721,
    }));
}

/**
 * Обрезка текста в блоке about
 */
function sliceText() {
    const kurortAboutText = document.querySelector('.js-kurortAboutText');
    while (kurortAboutText && kurortAboutText.scrollHeight > kurortAboutText.offsetHeight && kurortAboutText.childElementCount) {
        const wordArray = kurortAboutText.lastChild.innerText.split(' ');
        while (kurortAboutText.scrollHeight > kurortAboutText.offsetHeight && wordArray.length) {
            wordArray.pop();
            kurortAboutText.lastChild.innerText = wordArray.join(' ') + '...';
        }
        if (!wordArray.length) {
            kurortAboutText.removeChild(kurortAboutText.lastChild);
        }
    }
}
sliceText();

// Лайфхак для слайдера с подсказками
utils.addTrigger('mouseenter', '.Slide-dest__plate', function() {
    document.querySelectorAll('.swiper-wrapper').forEach($element => {
        $element.style.paddingBottom = '26px';
        $element.style.height = '425px';
    });
    
    document.querySelectorAll('.Houses-more-button').forEach($button => {
        $button.style.position = 'static'
    });
});

utils.addTrigger('mouseleave', '.Slide-dest__plate', function(){
    document.querySelectorAll('.swiper-wrapper').forEach($element => {
        $element.style.paddingBottom = '1px';
    });
    
    document.querySelectorAll('.Houses-more-button').forEach($button => {
        $button.style.position = 'relative';
    });
});

// выпадающее меню
document.querySelectorAll('.js-kurortFilter').forEach($kurortFilter => {
    $kurortFilter.addEventListener('click', function(e) {
        e.preventDefault();

        const $target = e.currentTarget;
        const $list = $target.querySelector('.js-kurortFilterList');
        const itemsHeight = [...$target.querySelectorAll('.js-kurortFilterItem')].reduce((acc, $item) => acc += $item.offsetHeight, 0);
        const targetHeight = $target.offsetHeight;

        if (!$target.classList.contains('is-active')) {
            $target.parentElement.style.width = `${$target.offsetWidth}px`;
            $target.parentElement.style.height = `${targetHeight}px`;

            $list.style.height = '1px';
            $target.style.height = `${targetHeight + 1}px`;
            
            setTimeout(() => {
                $list.style.height = `${itemsHeight}px`;
                $target.style.height = `${targetHeight + itemsHeight}px`;
            }, 10);
        } else {
            $target.parentElement.style.width = '';

            $target.style.height = `${$target.offsetHeight - itemsHeight}px`;
            $list.style.height = '';
        }

        $target.classList.toggle('is-active');
    });
});

// метрика
if (window.pageData['retail-rocket']['geo-id']) {
    const geoId = Number(window.pageData['retail-rocket']['geo-id']);
    (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function() {
        try { rrApi.categoryView(geoId); } catch(e) {}
        collectRetail(metrikaCollector, 'categoryView', {data: {geoId}});
    });
}
